export enum ReportType {
  project = 'project',
  reference = 'reference'
}
